import { useContext, useEffect } from 'react';
import { Box } from '@mui/system';
import { CircularProgress } from '@mui/material';
import { fetchAuthSession } from 'aws-amplify/auth';
import 'aws-amplify/auth/enable-oauth-listener';
import { AppContext } from '../../store/AppProvider';
import { SET_ROLES, SET_USER_NAME, UPDATE_LOGGED_IN_USER } from '../../store/reducer/LoggedInUserReducer';
import { getActiveRole } from '../../utils/Utils';

export function Callback() {
    const { setName, setRoles, setLoggedInUser, setActiveRole } = useContext(AppContext)
    useEffect(() => {
        fetchAuthSession().then((data) => {
            const payld = data?.tokens?.idToken?.payload
            const displayName = payld?.['custom:displayname'] || `${payld['given_name']} ${payld['family_name']}`
            const roles = payld['custom:accessrole']?.split(",")
            const activeRole = getActiveRole(roles)
            setLoggedInUser({ type: UPDATE_LOGGED_IN_USER, payload: { loggedIn: Boolean(payld['email']) } })
            setName({ type: SET_USER_NAME, payload: { displayName, family_name: payld['family_name'], given_name: payld['given_name'] } })
            setRoles({ type: SET_ROLES, payload: { roles } })
            setActiveRole(activeRole)
        })
            .then(() => {
                //    window.location.replace('/')
            }).catch((error) => {
                console.log("Something Went Wrong > ", error)
            })
    }, [setActiveRole, setLoggedInUser, setName, setRoles])

    return (
        <Box sx={{ display: "flex", position: "absolute", minWidth: "-webkit-fill-available", minHeight: "-webkit-fill-available" }}>
            <CircularProgress sx={{ margin: "auto" }} />
        </Box>
    )
}
